import SectionBlock from './Section.vue'
import ButtonGroupBlock from './ButtonGroup.vue'

export default {
    SectionBlock,
    ButtonGroupBlock,
}
